<template>
    <div class="buildContainer">
        <div class="buildTop">
            <div class="buildIcon"></div>
            <div class="buildName">
                <div class="name">{{build.name}}</div>
                <div class="floor">{{build.floors}}层</div>
            </div>
        </div>
        <div class="buildBotton">
            <div class="buildarea">占地面积：{{build.area}}m<sup>2</sup></div>
            <div class="message">建筑信息：{{build.message}}</div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            build:{
                name:"鲁泰研发大楼",
                floors:11,
                area:'22187',
                message:'鲁泰研发大楼主要包含办公及商业区等，抗震设防烈度七度，绿色建筑2星，地上11层地下1层，建筑高度47.5M，是鲁泰园区重要的建筑之一。'
            }
        }
    },

}
</script>

<style lang="less" scoped>
/* 楼宇指示牌 */
.buildContainer{
    height: 185px;
    width: 21.6vw;
    height: 21vh;
    padding: 0 1.6vw 1vh;
    background-image: url(../../../assets/img/buildName.png);
    background-size: 100% 100%;
    margin-left: -42px;
    position: fixed;
    bottom: 30vh;
    left:30vw;
    z-index: 1;

    .buildTop{
        height:7.5vh ;
        overflow: hidden;
        padding:2vh 0 0 2vh;
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);

        .buildIcon{ 
            width: 4.2vh;
            height: 4.2vh;
            background-image: url(../../../assets/img/lutaidalou.png);
            background-size: 100% 100%;
            float: left;
            margin-top: 3rem;
        }

        .buildName{
            float: left;
            width: 14vw;
            height: 4.5vh;

            .name{
                font-size: 24rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #E6F3FD;
                margin-left: 0.7vw;

            }

            .floor{
                font-size: 14rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #E6F3FD;
                margin-left: 0.7vw;

            }
        }
    }

    .buildBotton{
        height:9.5vh ;
        padding:0 1.4vh ;
        font-size: 14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #E6F3FD;
        opacity: 0.5;

        .buildarea{
            height:3vh ;
            line-height: 3vh;
        }
    }
}
.buildContainer ::after{
    content: '';
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255,0.3);
    position: absolute;
    left: 1.5vw;
    top:7.3vh ;
}
.buildContainer ::before{
    content: '';
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255,0.3);
    position: absolute;
    right: 1.5vw;
    top:7.3vh ;
}

</style>